import type { MouseEventHandler } from "react";
import { NodeViewWrapper } from "@tiptap/react";
import { AudioPlayer } from "@circle-react-shared/uikit/TipTapBlockEditor/FileExtension/AudioPlayer";
import { CloseButton } from "./CloseButton";

interface VoiceMessageRendererProps {
  attachment: any;
  isEditable: boolean;
  onDelete: MouseEventHandler<HTMLButtonElement>;
}

export const VoiceMessageRenderer = ({
  attachment,
  isEditable,
  onDelete,
}: VoiceMessageRendererProps) => (
  <NodeViewWrapper
    id="file-wrapper"
    as="div"
    className="group relative max-w-[500px]"
  >
    {isEditable && <CloseButton onClick={onDelete} />}
    <AudioPlayer
      src={attachment.url}
      controls={["play", "progress", "current-time"]}
      isVoiceMessage
      transcriptionId={attachment.metadata?.transcript_id}
      transcriptionPreview={attachment.metadata?.transcript_preview}
    />
  </NodeViewWrapper>
);
